export const INTAKE_CLOSED_COPY = {
  en: "We are not accepting new applications at the moment. Existing applications can still be resumed and updated.",
  ar: "لا نستقبل طلبات جديدة حاليًا. يمكنك متابعة طلبك الحالي وتحديث مستنداته كالمعتاد.",
} as const;
